import React from "react";
import PropTypes from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "redux-form";
import CustomTextArea from "../../../shared/CustomTextArea";
import isObject from "lodash/isObject";

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

const defaultProps = {
  value: ""
};

function renderTextArea({ input, meta: { touched, error }, ...others }) {
  let datos = input.value;

  if (isObject(input.value)) datos = input.value.value;

  return <CustomTextArea {...input} value={datos} {...others} />;
}

class Observaciones extends React.Component {
  state = { value: this.props.value || "" };

  handleChange = ({ value: { value } }) => {
    this.setState({ value });
  };

  render() {
    return (
      <Segment>
        <Header as="h4">Notas:</Header>
        <p />
        <label>
          Indique aquí si el niño o niña padece alguna enfermedad, alergias o
          cualquier otra cosa que considere relevante. Indique también que
          semana o semanas asistirá a la Escuela de Verano:
          <Field
            label="Notas"
            placeholder="Notas"
            name="notas"
            value={this.state.value}
            onChange={this.handleChange}
            component={renderTextArea}
          />
        </label>
      </Segment>
    );
  }
}

Observaciones.propTypes = propTypes;
Observaciones.defaultProps = defaultProps;

export default Observaciones;



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/hojaPreinscripcion/formularioInscripcion/Observaciones.jsx